import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { FormButton, InputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const EmailServiceProvider = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        emailServiceProviderID:'',
        serverName: '',
        userName: '',
        password: '',
        displayName: '',
        emailID: '',
        host: '',
        portNo: '',
        isSecure:false,
        isActive: true
    });

    const getEmailServiceProviderData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/GeneralSetting/ShowEmailServiceProvider`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            emailServiceProviderID: '',
            serverName: '',
            userName: '',
            password: '',
            displayName: '',
            emailID: '',
            host: '',
            portNo: '',
            isSecure: false,
            isActive: true
        });
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/GeneralSetting/InsertUpdateEmailServiceProvider`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/GeneralSetting/EditEmailServiceProvider`, { emailServiceProviderID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/GeneralSetting/DeleteEmailServiceProvider`, { emailServiceProviderID: id }, getEmailServiceProviderData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getEmailServiceProviderData(value);
    };

    useEffect(() => {
        getEmailServiceProviderData()
        document.title = 'Email Service Provider'
        inputrefs.current['txtServerName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Email Service Provider'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <InputBox
                                id="txtServerName"
                                type="text"
                                label='Server Name'
                                required={true}
                                placeholder="Server Name"
                                maxLength='50'
                                value={formData.serverName}
                                onChange={(e) => setFormData({ ...formData, serverName: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailID'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                type="email"
                                id="txtEmailID"
                                label='Email ID'
                                required={true}
                                placeholder="Email ID"
                                maxLength='50'
                                name='EmailId'
                                value={formData.emailID}
                                onChange={(e) => setFormData({ ...formData, emailID: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtUserName'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                id="txtUserName"
                                type="text"
                                label='User Name'
                                required={true}
                                placeholder="User Name"
                                maxLength='50'
                                value={formData.userName}
                                onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPassword'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                id="txtPassword"
                                type="password"
                                placeholder="Password"
                                label={'Password'}
                                required={true}
                                value={formData.password}
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtHost'].focus()
                                    }
                                }}
                            />
                           
                           
                            <InputBox
                                id="txtHost"
                                type="text"
                                label='Host'
                                required={true}
                                placeholder="Host"
                                maxLength='50'
                                value={formData.host}
                                onChange={(e) => setFormData({ ...formData, host: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPortNo'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                id="txtPortNo"
                                type="text"
                                label='Port'
                                required={true}
                                placeholder="Port"
                                maxLength='50'
                                value={formData.portNo}
                                onChange={(e) => setFormData({ ...formData, portNo: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtDisplayName'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                id="txtDisplayName"
                                type="text"
                                label='Display Name'
                                required={true}
                                placeholder="Display Name"
                                maxLength='50'
                                value={formData.displayName}
                                onChange={(e) => setFormData({ ...formData, displayName: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtSecure'].focus()
                                    }
                                }}
                            />
                            <Switch
                                inputrefs={inputrefs}
                                label='Secure'
                                checked={formData.isSecure}
                                id='txtSecure'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, isSecure: e.target.checked })}
                            />
                            <Switch
                                inputrefs={inputrefs}
                                label='Active'
                                checked={formData.isActive}
                                id='txtActive'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                            />
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(`/api/GeneralSetting/ShowEmailServiceProvider`, filterData, 'Email Service Provider')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'EmailServiceProvider'}
                handleFilter={() => {
                    getEmailServiceProviderData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default EmailServiceProvider;
